module.exports = __webpack_public_path__ + "img/about-show.f62e207d.png";